import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { BlogsEndpoints } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";
import { dateFormatter } from "../../utils/Utils";
import parse from "html-react-parser";
import CompanyLogo from "../../common/CompanyLogo";
import { BASE_URL } from "../../api/endpoints";
import { useLocation } from "react-router-dom";
import { comment, reply } from "../../api/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { setBlogcomment, setLoader, setReply } from "../../redux/slice/Slice";
import { FaCalendarAlt, FaUserAlt } from "react-icons/fa";
import ErrorMessage from "../../common/errormsg/ErrorMessage";

function Blog() {
  const locations = useLocation();
  const dispatch = useDispatch();
  const data = locations.state?.item;
  const [commentdata, setComment] = useState([]);
  const [activeComment, setActiveComment] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [Recentblog, setrecentBlog] = useState([])
  const [recenttrending, setrecenTrending] = useState([])
  const [page, setPage] = useState(1); // Pagination state
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // To track if more testimonials are available
  const api = Api_Instance.unAuth();

  useEffect(() => {
    dispatch(setLoader(true))
  }, []);
  const GetBlogs = async (pageNumber) => {
    setIsLoading(true);
    try {
      const BlogsResponse = await api("GET", `${BlogsEndpoints?.GET_BLOGS_API}?page_size=4&page=${pageNumber}`);
      const newBlogsResponse = BlogsResponse?.data?.data;

      if (newBlogsResponse.length > 0) {
        setBlogs((prev) => [...prev, ...newBlogsResponse]);
        if (BlogsResponse?.data?.data) {
          dispatch(setLoader(false))
        }
        setHasMore(newBlogsResponse.length === 4); // If less than 10 items, assume no more pages
      } else {
        setHasMore(false); // No more testimonials
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    GetBlogs(page);
  }, []);
  const handleReplyClick = (commentId) => {
    setActiveComment(activeComment === commentId ? null : commentId);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [commentsPerPage] = useState(5);

  const paginatedComments = commentdata.slice(0, currentPage * commentsPerPage);

  const loadMoreComments = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const item = ""
  const words = item?.description ? item.description.split(" ") : [];


  const shortDescription = words?.slice(0, 50).join(" ");

  const handleparse = (words) => {
    let trimVal = ""
    trimVal = words?.slice(0, 500);
    return parse(trimVal)
  }
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const blogType = () => {
    const recentStatus = [];
    const trendingStatus = [];

    blogs?.forEach((item) => {
      if (item?.status) {
        if (item?.blog_type === "recent blog") {
          recentStatus.push(item);
        } else if (item?.blog_type === "trending") {
          trendingStatus.push(item);
        }
      }
    });

    setrecentBlog(recentStatus);
    setrecenTrending(trendingStatus);
  };

  useEffect(() => {
    blogType();
  }, [blogs]);

  const loadMoreTestimonials = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    GetBlogs(nextPage);
  };
  return (
    <div
      style={{
        zIndex: 999,
      }}
    >
      <CompanyLogo title={"Blogs"} subtitle={"Blogs"} />

      <div className="flex md:flex-row flex-col justify-between items-start gap-5 w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
        <div className="w-full mt-10">
          {blogs ? (
            blogs?.map(
              (item, index) =>
                item.status && (
                  <div
                    key={index}
                    className="bg-card_bg_color w-full rounded-lg border space-y-3 mb-6"
                  >
                    <div className="flex justify-center p-3">
                      <img
                        className="w-full min-w-[400px] object-cover h-[400px] rounded-md"
                        src={`${item?.image}`}
                        alt="Blog Post"
                      />
                    </div>
                    <div className="w-full p-4">
                      <p className="text-primaryColor uppercase text-lg font-semibold">
                        {item?.heading}
                      </p>
                      {/* <p className="text-lg font-semibold text-text_color mt-2">
                    22nd Parallel Franchise Cost – How to get, Contact, Apply,
                    Fee
                  </p> */}
                      <hr className="mt-2" />
                      <div className="flex gap-4 mt-3">
                        <div className="flex gap-2">
                          <span>
                            <FaUserAlt />

                          </span>
                          <p className="text-sm">Admin</p>
                        </div>
                        <div className="flex gap-2">
                          <span>
                            <FaCalendarAlt />
                          </span>
                          <p className="text-sm">
                            {dateFormatter(item?.created_time)}
                          </p>
                        </div>
                      </div>
                      <div className="mt-2">
                        <p className="text-subtext_color">
                          {isExpanded
                            ? parse(item?.description)
                            : handleparse(item?.description)}
                        </p>

                        <div className="mt-2">
                          <NavLink
                            onClick={toggleReadMore}
                            className="text-primaryColor cursor-pointer"
                            state={{ item: item }}
                            to={'/blogdetails'}
                          >
                            READ MORE
                            {/* {isExpanded ? "SHOW LESS" : "READ MORE"}{" "} */}
                            {/* Single button */}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-1 mt-1"
                            />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )
          ) : (
            <div>NO Blogs Found</div>
          )}
        </div>

        <div className="sticky top-10 flex flex-col space-y-4 mt-10 w-full md:w-1/2">
          {Recentblog[0]?.blog_type.length >= 0 &&
            <div className="w-full h-auto bg-card_bg_color p-3 border rounded-lg sticky top-0">
              <div className="w-full">
                <h3 className="font-semibold text-2xl text-secondaryColor">{"Recent Blog"}</h3>
                <hr className="mt-2 w-full" />
              </div>
              {Recentblog?.map((item) => (
                <div className="w-full p-2" key={item?.id}>
                  <h3 className="text-text_color">{item?.heading}</h3>
                  <p className="text-subtext_color text-sm mt-1">
                    by Admin, {dateFormatter(item?.created_time)}
                  </p>
                </div>
              ))}
            </div>

          }

          {recenttrending[0]?.blog_type.length >= 0 &&
            <div className="w-full h-auto bg-card_bg_color p-3 border rounded-lg sticky top-0">
              <div className="w-full">
                <h3 className="font-semibold text-2xl text-secondaryColor">{"Trending Blog"}</h3>
                <hr className="mt-2 w-full" />
              </div>
              {recenttrending?.map((item) => (
                <div className="w-full p-2" key={item?.id}>
                  <h3 className="text-text_color">{item?.heading}</h3>
                  <p className="text-subtext_color text-sm mt-1">
                    by Admin, {dateFormatter(item?.created_time)}
                  </p>
                </div>
              ))}
            </div>

          }
        </div>
        
      </div>
        {hasMore && (
          <div className="mt-5 flex justify-center">
            <button
              className="px-4 py-2 bg-primaryColor text-white rounded-lg"
              onClick={loadMoreTestimonials}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}

    </div>
  );
}

export default Blog;
